module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAAAXNSR0IArs4c6QAAAMNJREFUKFNjZEADXwIV9f/+Z0xn+v/fkYGBUREi/f8+AyPj/j8M/2YJbnhwAVkLI4zz2FKGU0CCrZ/h//9UBgZGJnSDoQb9Y2BknP3hxa9C2eNPvoPEwAaANYuzbmdgYLTHrhFd9P/BDy9/e4IMARvw2V9pBgMjQzpxmqGqGBlm8q6/l8EI8vP//wzncDsbl7H///1h+G/M+DlAaSoDA0MWSbYjFE9j/OyvdIOBkUGdLAP+M9wEueAHAwMDO1kGMDD8BACXQT0rU8/onQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/椭圆 2.png
// module id = kliC
// module chunks = 3